import PhoneSetting from './PhoneSetting';

export { PhoneSetting };
